import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';
import { useEffect } from 'react';

export const useCustomHederSideMenu = (): void => {
  const { setWithNavigation, setWithBell } = useCustomizeHeaderContext();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(setWithNavigation, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(setWithBell, []);
};
